import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <svg className="empty-state__icon" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <rect
          x="8"
          y="10"
          width="32"
          height="28"
          rx="4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path d="M8 18h32" stroke="currentColor" strokeWidth="2" />
        <path d="M18 27h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <p className="empty-state__title">{title}</p>
      {description && <p className="empty-state__description">{description}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
